import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { $tf } from "@/plugins/i18n";
import { INTERVAL as INTERVAL_ENUM } from "@/utils/const";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DatePickerControlButton',
    props: {
        selectedInterval: {},
        iconDirection: {},
        onClick: { type: Function }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const click = () => {
            emit("click");
        };
        const ariaLabel = computed(() => {
            if (props.selectedInterval === INTERVAL_ENUM.DAILY) {
                return props.iconDirection === "left"
                    ? $tf("timeManagement.previousDay.label")
                    : $tf("timeManagement.nextDay.label");
            }
            else if (props.selectedInterval === INTERVAL_ENUM.WEEKLY) {
                return props.iconDirection === "left"
                    ? $tf("timeManagement.previousWeek.label")
                    : $tf("timeManagement.nextWeek.label");
            }
            else {
                return "";
            }
        });
        const tooltip = computed(() => {
            if (props.selectedInterval === INTERVAL_ENUM.DAILY) {
                return props.iconDirection === "left"
                    ? $tf("timeManagement.previousDay.tooltip")
                    : $tf("timeManagement.nextDay.tooltip");
            }
            else if (props.selectedInterval === INTERVAL_ENUM.WEEKLY) {
                return props.iconDirection === "left"
                    ? $tf("timeManagement.previousWeek.tooltip")
                    : $tf("timeManagement.nextWeek.tooltip");
            }
            else {
                return "";
            }
        });
        return (_ctx, _cache) => {
            const _component_Button = _resolveComponent("Button");
            const _directive_tooltip = _resolveDirective("tooltip");
            return _withDirectives((_openBlock(), _createBlock(_component_Button, {
                size: "small",
                severity: "primary",
                icon: `pi pi-chevron-${__props.iconDirection}`,
                variant: "text",
                "aria-label": ariaLabel.value,
                onClick: click,
                pt: {
                    root: {
                        class: ['!bg-surface-100 hover:!bg-surface-200', '!py-1'],
                    },
                    icon: {
                        class: '!text-surface-800 !text-xs',
                    },
                }
            }, null, 8, ["icon", "aria-label"])), [
                [
                    _directive_tooltip,
                    tooltip.value,
                    void 0,
                    { top: true }
                ]
            ]);
        };
    }
});
